import { Stack, Text } from '@ltvco/refresh-lib/theme';
import { useSession } from '@ltvco/refresh-lib/v1';
import { VehicleDisclaimer } from '@ltvco/refresh-lib/v2';
import { useEffect, useState } from 'react';

export const CustomDisclaimer = () => {
  const {
    session: { account },
  } = useSession();
  const isCAUser = account?.account?.subscription_info?.user_country === 'CA';

  const [preferredLanguage, setPreferredLanguage] = useState<string | null>(
    () =>
      typeof window !== 'undefined'
        ? localStorage.getItem('preferred_language')
        : null,
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    setPreferredLanguage(localStorage.getItem('preferred_language'));

    const handleStorageChange = () => {
      setPreferredLanguage(localStorage.getItem('preferred_language'));
    };

    window.addEventListener('languageChanged', handleStorageChange);

    return () => {
      window.removeEventListener('languageChanged', handleStorageChange);
    };
  }, []);

  const showTranslationDisclaimer =
    preferredLanguage !== null && preferredLanguage !== 'en';

  return (
    <Stack data-cy="footer_disclaimer" spacing={3} maxWidth={1290}>
      {isCAUser ? (
        <Text variant="body2" color="text.secondary">
          This report does not contain detailed information regarding a
          vehicle's repair history nor information on all motor vehicles in
          Canada, because some provinces are not yet providing their vehicle
          data to the system. Currently, the data provided by provinces is
          provided in a variety of time frames; while some provinces report and
          update data in "real-time" (as registration transactions occur), other
          provinces send updates less frequently. Information on previous,
          significant vehicle damage may not be included in the system if the
          vehicle was never determined by an insurance company to be a "total
          loss" or branded by a state registration agency.
          <br />
          <br />
          A vehicle history report is NOT a substitute for an independent
          vehicle inspection. Before making a decision to purchase a vehicle,
          users are strongly encouraged to also obtain an independent vehicle
          inspection to ensure the vehicle does not have hidden damage. Bumper
          may not include information on commercial vehicles if those records
          are not part of a province's primary database for registration records
          (in some provinces, those vehicles are managed by a separate agency).
          These records may be incorporated at a later date.
          <br />
          <br />
          The information used to compile this report is aggregated from various
          government agencies, non-profit organizations, and industry sources.
          The accuracy and reliability of the information supplied depend
          primarily on the reporting sources, and all entities involved in
          compiling this report accept no liability for any errors or omissions.
          The information provided does not contain or constitute personal
          information. Cost of Ownership data is ©2025 Vincentric, LLC, and is
          provided by Vincentric AS IS without warranty or guarantee of any
          kind. Vincentric disclaims all warranties or conditions of any kind,
          expressed or implied, with respect to such data, including the implied
          warranties of merchantable quality and fitness for a particular
          purpose.
          <br />
          <br />
          Bumper reports are based upon data available and may include
          registration and vehicle status checks records from 10 provinces and
          territorial-level agencies, including Quebec, British Columbia,
          Alberta, Manitoba, Saskatchewan, Nova Scotia, Newfoundland and
          Labrador, Prince Edward Island, Yukon, and Northwest Territories, to
          the extent such specific data has been compiled, digitized locally,
          and is available. We strongly recommend your own due diligence and
          checking additional sources for provinces not listed above. As a
          reminder, even for jurisdictions where data is provided, we cannot
          guarantee the completeness or accuracy of the information, and you
          should not rely solely on the data when making decisions.
        </Text>
      ) : (
        <>
          <Text variant="body2" color="text.secondary">
            The information contained in any report and on our website is not
            necessarily 100% accurate, complete or up to date, nor a substitute
            for your own due diligence, especially concerning such sensitive
            items as criminal history, relatives, mortgages and liens. Our data
            comes from a wide variety of sources, but some municipalities and
            jurisdictions are slow to report and digitize their data, so we
            cannot guarantee or warrant full accuracy of ALL search results.
          </Text>
          <VehicleDisclaimer fontSize="14px" />
        </>
      )}
      {showTranslationDisclaimer && (
        <Text variant="body2" color="text.secondary">
          THIS SERVICE MAY CONTAIN TRANSLATIONS POWERED BY GOOGLE. GOOGLE
          DISCLAIMS ALL WARRANTIES RELATED TO THE TRANSLATIONS, EXPRESS OR
          IMPLIED, INCLUDING ANY WARRANTIES OF ACCURACY, RELIABILITY, AND ANY
          IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
          PURPOSE AND NONINFRINGEMENT.
          <br />
          Automated translations are imperfect, and the original English version
          of this site is the authoritative version.
        </Text>
      )}
    </Stack>
  );
};
